import bigfoot from '$lib/PageSections/FeaturedArticles/images/Bigfoot-Profile-square.jpg?w=250';
import increaseValue from '$lib/PageSections/FeaturedArticles/images/increaseValue.png?w=250';
import pickleball from '$lib/PageSections/FeaturedArticles/images/pickeball-thumb.jpg?w=250';
import taxCredits from '$lib/PageSections/FeaturedArticles/images/taxcredits.jpg?w=250';
import homeEnergyScore from '$routes/(public)/how-to/improve-home-energy-score/images/Jason-Elton-DSC0060-1.jpg?w=250';
import soundProofing from '$routes/(public)/how-to/soundproof-your-home/images/man-installing-soundproofing-window-inserts.jpg?w=250';
import localLaw97 from '$routes/(public)/resources/blog/about-local-law-97-nyc/images/nyc_skyline.jpg?w=250';
import energyEfficientWindowMyths from '$routes/(public)/resources/blog/energy-efficient-window-myths/images/energy-efficient-window-replacement.jpg?w=250';
import apartmentInsulation from '$routes/(public)/resources/blog/insulating-apartment-windows/images/womanNextToRadiator.jpg?w=250';
import blockHeat from '$routes/(public)/resources/blog/keep-cool-save-energy-block-heat/images/trouble_keeping_house_cool.jpeg?w=250';
import retrofit from '$routes/(public)/resources/blog/retrofit-attachment-vs-replacement/images/09-indow-windows-copypp_w1600_h1067.jpg?w=250';
import energyEfficiency from '$routes/(public)/resources/blog/ways-to-save-with-energy-efficiency/images/Woman-thermostat-1200x800.jpg?w=250';

export const featured = [
	{
		header: 'SAVE MONEY',
		title: 'How to Get Energy Tax Credits with Window Inserts',
		href: '/how-to/get-home-energy-efficiency-tax-credits',
		image: taxCredits,
		featured: true,
	},
	{
		header: 'BLOCK HEAT',
		title: 'How to Keep Cool & Save Energy This Summer',
		href: '/solutions/insulate-windows-from-heat',
		image: blockHeat,
		featured: true,
	},
	{
		header: 'INCREASE VALUE',
		title: 'Increase The Resale Value Of Your Home With Inserts',
		href: '/how-to/increase-home-resale-value',
		image: increaseValue,
		featured: true,
	},
	{
		header: 'CREATURE COMFORTS',
		title: 'See How Bigfoot Blocks Out Noisy Neighbors',
		href: '/bigfoot',
		image: bigfoot,
		featured: true,
	},
];

export const articles = [
	...featured,

	{
		header: 'PICKLEBALL NOISE',
		title: "Acoustic Inserts Shut Out Pickleball's Painful Pounding",
		href: '/resources/blog/block-pickleball-noise',
		image: pickleball,
		featured: false,
	},
	{
		header: 'REPLACEMENT MYTHS',
		title: 'The Downsides To Energy Efficient Window Replacement',
		href: '/resources/blog/energy-efficient-window-myths',
		image: energyEfficientWindowMyths,
		featured: false,
	},
	{
		header: 'SOUNDPROOFING GUIDE',
		title: 'What To Know About Soundproofing Your Home',
		href: '/how-to/soundproof-your-home',
		image: soundProofing,
		featured: false,
	},
	{
		header: 'HOME ENERGY SCORE',
		title: 'How To Improve Your Score And Increase Home Value',
		href: '/how-to/improve-home-energy-score',
		image: homeEnergyScore,
		featured: false,
	},
	{
		header: 'LOCAL LAW 97',
		title: 'The Road To Sustainable Commercial Buildings Starts In NYC',
		href: '/resources/blog/about-local-law-97-nyc',
		image: localLaw97,
		featured: false,
	},
	{
		header: 'RETROFITTING',
		title: 'Learn About Retrofit Options & Costs',
		href: '/resources/blog/retrofit-attachment-vs-replacement',
		image: retrofit,
		featured: false,
	},
	{
		header: 'APT INSULATION',
		title: 'Why Insulating Your Apartment Can Be A Great Investment',
		href: '/resources/blog/insulating-apartment-windows',
		image: apartmentInsulation,
		featured: false,
	},
	{
		header: 'ENERGY EFFICIENCY',
		title: 'Save Money & Save The Enivronment',
		href: '/resources/blog/ways-to-save-with-energy-efficiency',
		image: energyEfficiency,
		featured: false,
	},
];
